import { render, staticRenderFns } from "./ExportHistoryCard.vue?vue&type=template&id=16986c19&"
import script from "./ExportHistoryCard.vue?vue&type=script&lang=js&"
export * from "./ExportHistoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports